const _WGSL_debug = class {
  constructor(bindgroup_num, buf_unit_entries_count) {
    this.shader_active = () => `@group(${this.bindgroup_num}) @binding(0) var<storage,read_write> _dbg: array<u32>;

var<private> _dbg_unit: u32;

fn dbg_init(uid: u32) {
	/* initialize debug unit for this uid */
	_dbg_unit = ${_WGSL_debug.BUF_HEADER_SIZE}u + uid*${this.buf_unit_size()}u;
	_dbg[_dbg_unit] = 0u; // entries count
}

fn dbg_32m(mark: i32, val: u32, vtype: i32) {
	/* limit entries count, but still store the total number of calls */
	var entry_count = _dbg[_dbg_unit];
	_dbg[_dbg_unit] = entry_count + 1u;
	if (entry_count == ${this.buf_unit_entries_count}u) {
		return;
	}

	/* store data in a new debug unit entry */
	var entry_off = _dbg_unit + 1u + entry_count * ${_WGSL_debug.BUF_ENTRY_SIZE}u;
	_dbg[entry_off] = u32(vtype);
	_dbg[entry_off + 1u] = val;
	_dbg[entry_off + 2u] = u32(mark);
}

fn dbg_u32m(mark: i32, val: u32) { dbg_32m(mark, val, ${_WGSL_debug.BUF_ENTRY_TYPE_U32}); }
fn dbg_i32m(mark: i32, val: i32) { dbg_32m(mark, bitcast<u32>(val), ${_WGSL_debug.BUF_ENTRY_TYPE_I32}); }
fn dbg_f32m(mark: i32, val: f32) { dbg_32m(mark, bitcast<u32>(val), ${_WGSL_debug.BUF_ENTRY_TYPE_F32}); }
fn dbg_32(val: u32, vtype: i32) { dbg_32m(${_WGSL_debug.BUF_ENTRY_MARK_UNSET}, val, vtype); }
fn dbg_u32(val: u32) { dbg_u32m(${_WGSL_debug.BUF_ENTRY_MARK_UNSET}, val); }
fn dbg_i32(val: i32) { dbg_i32m(${_WGSL_debug.BUF_ENTRY_MARK_UNSET}, val); }
fn dbg_f32(val: f32) { dbg_f32m(${_WGSL_debug.BUF_ENTRY_MARK_UNSET}, val); }`;
    this.buf_unit_size = () => _WGSL_debug.BUF_UNIT_HEADER_SIZE + this.buf_unit_entries_count * _WGSL_debug.BUF_ENTRY_SIZE;
    this.buf_unit_size_bytes = () => Uint32Array.BYTES_PER_ELEMENT * this.buf_unit_size();
    this.bindgroup_num = bindgroup_num;
    this.buf_unit_entries_count = buf_unit_entries_count === void 0 ? _WGSL_debug.BUF_UNIT_ENTRIES_COUNT_DEFAULT : buf_unit_entries_count;
    this.record = new Array();
    this.pass_n = 0;
  }
  set_output(output) {
    output.attach(this);
    this.output = output;
  }
  add_shader(src, active) {
    if (active) {
      if (src.search(/^[ \t]*dbg_init/m) < 0) {
        alert("your shader does not contain any dbg_init() call, debug will not work properly");
      }
    }
    var debug_src = active ? this.shader_active() : _WGSL_debug.SHADER_INACTIVE;
    this.marks = new Array();
    const dbgm_calls = src.matchAll(/^[ \t]*dbg_[uif]?32m[ \t]*\([ \t]*(?<value>[0-9]+)[^;]*;[ \t]*(\/\/|\/\*)(?<comment>.*)/mg);
    for (const call of dbgm_calls) {
      const value = Number(call.groups["value"]);
      const comment = call.groups["comment"].trim();
      this.marks[value] = comment;
    }
    console.log(`WGSL_debug add_shader ${JSON.stringify(this.marks)}`);
    return debug_src + "\n" + src;
  }
  setup(device, unit_count) {
    console.log("WGSL_debug setup");
    this.device = device;
    this.unit_count = unit_count;
    this.buf_size = _WGSL_debug.BUF_HEADER_SIZE_BYTES + unit_count * this.buf_unit_size_bytes();
    console.log(`WGSL_debug unit_count=${unit_count} buf_size=${this.buf_size}`);
    if (this.buf) {
      this.buf.destroy();
    }
    this.buf = device.createBuffer({
      size: this.buf_size,
      usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC
    });
    if (this.dstbuf) {
      this.dstbuf.destroy();
    }
    this.dstbuf = device.createBuffer({
      size: this.buf_size,
      usage: GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST
    });
    this.record = new Array();
    this.pass_n = 0;
    if (this.output) {
      this.output.reset();
    } else {
      console.log(`WGSL_debug output format: <debug_header>
<global_invoke_id> <debug_call_n> [<record_count>] <pass_last-${this.buf_unit_entries_count}...last>`);
    }
  }
  create_bindgroup(pipeline) {
    this.bindgroup = this.device.createBindGroup({
      layout: pipeline.getBindGroupLayout(this.bindgroup_num),
      entries: [{ binding: 0, resource: { buffer: this.buf } }]
    });
  }
  set_bindgroup(pass) {
    pass.setBindGroup(this.bindgroup_num, this.bindgroup);
  }
  fetch(cmd) {
    cmd.copyBufferToBuffer(this.buf, 0, this.dstbuf, 0, this.buf_size);
  }
  async process(cb_data) {
    await this.dstbuf.mapAsync(GPUMapMode.READ);
    const buf = this.dstbuf.getMappedRange();
    const buf_u32 = new Uint32Array(buf);
    const buf_i32 = new Int32Array(buf);
    const buf_f32 = new Float32Array(buf);
    var pass_data;
    this.hang_detect("reset");
    pass_data = Array.from(Array(this.unit_count), () => new Array());
    for (var uid = 0; uid < this.unit_count; uid += 1) {
      if (this.hang_detect("process")) {
        break;
      }
      const unit_off = _WGSL_debug.BUF_HEADER_SIZE + uid * this.buf_unit_size();
      const entry_count = buf_u32[unit_off];
      if (entry_count > 0) {
        if (entry_count > this.buf_unit_entries_count) {
          console.warn(`WGSL debug: ${entry_count} debug calls where made from unit_id=${uid}, but only the first ${this.buf_unit_entries_count} where recorded
Consider increasing buf_unit_entries_count.`);
        }
        for (var entry = 0; entry < Math.min(entry_count, this.buf_unit_entries_count); entry++) {
          const entry_off = unit_off + _WGSL_debug.BUF_UNIT_HEADER_SIZE + entry * _WGSL_debug.BUF_ENTRY_SIZE;
          const type = buf_u32[entry_off];
          var value = -1;
          if (type == _WGSL_debug.BUF_ENTRY_TYPE_U32) {
            value = buf_u32[entry_off + 1];
          } else if (type == _WGSL_debug.BUF_ENTRY_TYPE_I32) {
            value = buf_i32[entry_off + 1];
          } else if (type == _WGSL_debug.BUF_ENTRY_TYPE_F32) {
            value = buf_f32[entry_off + 1];
          }
          var mark = buf_u32[entry_off + 2];
          pass_data[uid].push({
            value,
            type,
            mark
          });
        }
      }
    }
    this.record.push(pass_data);
    var console_log = true;
    if (this.output) {
      console_log = false;
      this.output.update();
    }
    if (cb_data) {
      console_log = cb_data(this.pass_n, pass_data, this.record);
    }
    if (console_log) {
      console.log(`WGSL_debug ${buf_u32.slice(0, _WGSL_debug.BUF_HEADER_SIZE).toString()}`);
      var s = "";
      pass_data.forEach((entries, uid2) => {
        s += `${uid2} [${entries.length}] ${entries}
`;
      });
      console.log(s);
    }
    this.dstbuf.unmap();
    this.pass_n++;
  }
  clear_processed() {
    this.record.forEach((pass) => {
      pass.forEach((entries) => {
        entries.forEach((entry) => {
          entry.processed = false;
        });
      });
    });
  }
  hang_detect(current_op, resolution) {
    if (current_op != this.hang_detect_op) {
      this.hang_detect_op = current_op;
      this.hang_detect_start = Date.now();
      this.hang_detect_counter = 0;
      this.hang_detect_resolution = resolution ? resolution : _WGSL_debug.HANG_DETECT_RESOLUTION;
    } else {
      this.hang_detect_counter++;
      if (this.hang_detect_counter % this.hang_detect_resolution == 0) {
        const now = Date.now();
        if (now - this.hang_detect_start > _WGSL_debug.HANG_DETECT_LIMIT) {
          console.warn(`WGSL_debug hang detected in '${current_op}' after ${this.hang_detect_counter} iterations (${_WGSL_debug.HANG_DETECT_LIMIT}ms), interrupting operation`);
          this.hang_detect_op = null;
          return true;
        }
      }
    }
    return false;
  }
};
let WGSL_debug = _WGSL_debug;
WGSL_debug.BUF_HEADER_SIZE = 16;
WGSL_debug.BUF_HEADER_SIZE_BYTES = Uint32Array.BYTES_PER_ELEMENT * _WGSL_debug.BUF_HEADER_SIZE;
WGSL_debug.BUF_UNIT_HEADER_SIZE = 1;
WGSL_debug.BUF_UNIT_ENTRIES_COUNT_DEFAULT = 20;
WGSL_debug.BUF_ENTRY_SIZE = 3;
WGSL_debug.BUF_ENTRY_TYPE_U32 = 1;
WGSL_debug.BUF_ENTRY_TYPE_I32 = 2;
WGSL_debug.BUF_ENTRY_TYPE_F32 = 3;
WGSL_debug.BUF_ENTRY_MARK_UNSET = 999999;
WGSL_debug.HANG_DETECT_LIMIT = 500;
WGSL_debug.HANG_DETECT_RESOLUTION = 100;
WGSL_debug.SHADER_INACTIVE = `fn dbg_init(unit_id: u32) {}

fn dbg_u32(val: u32) {}
fn dbg_i32(val: i32) {}
fn dbg_f32(val: f32) {}
fn dbg_32(val: u32, vtype: u32) {}

fn dbg_u32m(mark: i32, val: u32) {}
fn dbg_i32m(mark: i32, val: i32) {}
fn dbg_f32m(mark: i32, val: f32) {}
fn dbg_32m(mark: i32, val: f32, vtype: i32) {}`;
class WGSL_debug_output {
  constructor() {
  }
  attach(debug) {
    console.log("WGSL_debug output attach");
    this.debug = debug;
  }
}
export { WGSL_debug, WGSL_debug_output };
//# sourceMappingURL=wgsl-debug.es.js.map
